import React from "react";
import { Container } from "react-bootstrap";

export default function Jumbotron({className, children}){
    return(
        <Container className={"px-lg-3 px-xl-5 px-0 py-5 mb-2 bg-light " + className}>
            {children}
        </Container>
    )
}